module.exports = __webpack_public_path__ + "img/icon-consumer.f388f423.svg";